class TimelinePinList extends TimelineListBase {
	constructor () {
		super();
	}
	addPin (pin) {
		this.add(pin, pin.id, pin.time);
	}
}